import { PatientTableDataFragment } from '../../../../generated/graphql';
import { getPatientsObject, PatientsObject } from '../helpers';

export const getSelectionInterval = (
  patientIndex: number,
  lastSelectedPatientIndex: number,
  patientsList: PatientTableDataFragment[] | null,
  isShiftKeyPressed: boolean,
) => {
  let selectionInterval: PatientTableDataFragment[] = [];

  if (patientsList && isShiftKeyPressed && lastSelectedPatientIndex !== -1) {
    if (lastSelectedPatientIndex < patientIndex) {
      selectionInterval = patientsList.slice(
        lastSelectedPatientIndex,
        patientIndex + 1,
      );
    } else {
      selectionInterval = patientsList.slice(
        patientIndex,
        lastSelectedPatientIndex + 1,
      );
    }
  }
  return getPatientsObject(selectionInterval);
};

export const getNewSelectedPatients = (
  isChecked: boolean,
  selectionInterval: PatientsObject,
  patient: PatientTableDataFragment,
  selectedPatientsObject: PatientsObject,
  isShiftKeyPressed: boolean,
  selectedPatientsList: PatientTableDataFragment[],
) => {
  const singlePatientObject: PatientsObject = {};
  if (patient.programInstanceId)
    singlePatientObject[patient?.programInstanceId] = patient;

  const hasInterval =
    isShiftKeyPressed && Object.keys(selectionInterval).length > 0;

  if (isChecked) {
    return {
      ...selectedPatientsObject,
      ...(hasInterval ? selectionInterval : singlePatientObject),
    };
  } else {
    const remainingSelectedPatients: PatientsObject = {};

    selectedPatientsList.forEach((selectedPatient) => {
      if (selectedPatient?.programInstanceId) {
        if (hasInterval) {
          if (!selectionInterval[selectedPatient?.programInstanceId]) {
            remainingSelectedPatients[selectedPatient?.programInstanceId] =
              selectedPatient;
          }
        } else {
          if (
            patient?.programInstanceId &&
            selectedPatient?.programInstanceId !== patient?.programInstanceId
          ) {
            remainingSelectedPatients[selectedPatient?.programInstanceId] =
              selectedPatient;
          }
        }
      }
    });

    return remainingSelectedPatients;
  }
};
